function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { createElement } from 'react';
var HtmlElement = function HtmlElement(props) {
  /* eslint-disable */
  var element = props.element,
    children = props.children,
    className = props.className,
    dataTestId = props.dataTestId,
    href = props.href,
    onClick = props.onClick,
    target = props.target,
    ariaLabel = props.ariaLabel;
  /* eslint-enable */

  var baseProps = {
    className: className,
    'data-test-id': dataTestId,
    href: href,
    target: target,
    rel: target ? 'noreferrer noopener' : '',
    'aria-label': ariaLabel,
    'aria-live': ariaLabel && 'assertive',
    lang: ariaLabel && 'pt-br'
  };
  if (onClick) {
    return /*#__PURE__*/createElement(element, _extends({}, baseProps, {
      onClick: onClick
    }), children);
  }
  return /*#__PURE__*/createElement(element, _extends({}, baseProps), children);
};
export default HtmlElement;